module.exports = __webpack_public_path__ + "img/introduce1.21924374.jpg";